import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import type { ContractFormValues } from '../schemas';

export function AdditionalInfoSection() {
  const { t } = useTranslation();
  const form = useFormContext<ContractFormValues>();

  return (
    <div className="space-y-4">
      <FormField
        name="name"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('contractName')} *</FormLabel>
            <FormControl>
              <Input {...field} placeholder={t('contractNamePlaceholder')} className="bg-white" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        name="description"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('description')}</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder={t('description')} className="bg-white min-h-[96px]" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        name="vidRabot"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('vidRabot')}</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder={t('typeOfTask')} className="bg-white min-h-[80px]" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        name="sudOrgan"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('sudOrgan')}</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder={t('sudOrgan')} className="bg-white min-h-[80px]" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        name="contactFace"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('contactFace')}</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder={t('contactFace')} className="bg-white min-h-[80px]" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid gap-4 md:grid-cols-2">
        <FormField
          name="contactPhone"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('contactPhone')}</FormLabel>
              <FormControl>
                <Input {...field} placeholder={t('contactPhonePlaceholder')} className="bg-white" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="contactEmail"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('contactEmail')}</FormLabel>
              <FormControl>
                <Input {...field} placeholder={t('contactEmailPlaceholder')} className="bg-white" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
